export const SAVE_GAME_FOR_RECOMMENDATIONS = 'SAVE_GAME_FOR_RECOMMENDATIONS';
